import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { DangerouslySetHtmlContent } from '@package/components';
const messages = defineMessages({
  tiket_subscribe: {
    id: 'Sign up from the comfort of your home',
    defaultMessage: 'Iscriviti comodamente da casa',
  },
  ticket_buy_now: {
    id: 'Buy your ticket now',
    defaultMessage: 'Acquista ora il biglietto!',
  },
});

const Ticket = ({ content, intl }) => {
  if (!content.ticket_url && !content.trekksoft_embed) {
    return null;
  }
  const description =
    content.ticket_box_text_description ||
    intl.formatMessage(messages.tiket_subscribe);
  const url_label =
    content.ticket_url_label ?? intl.formatMessage(messages.ticket_buy_now);

  let link = (
    <a href={content.ticket_url} rel="noopener noreferrer" target="_blank">
      {url_label}
    </a>
  );
  if (content.trekksoft_embed) {
    link = (
      <DangerouslySetHtmlContent
        html={content.trekksoft_embed}
        className="embed-html"
      />
      // <div
      //   className="embed-html"
      //   dangerouslySetInnerHTML={{
      //     __html: content.trekksoft_embed,
      //   }}
      // />
    );
  }

  return (
    <section className="cta-ticket">
      <div className="cta-ticket-text">{description}</div>
      <div className="cta-ticket-link">{link}</div>
    </section>
  );
};

Ticket.propTypes = {
  content: PropTypes.object.isRequired,
};

export default injectIntl(Ticket);
